import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const pause = (duration) => {
  return new Promise((resolve) => setTimeout(resolve, duration));
};

const brandApi = createApi({
  reducerPath: "brand",
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_BASE_ENDPOINT}api/`,
    prepareHeaders: (headers, { getState }) => {
      const token = localStorage.getItem("access-token");
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
    },
    fetchFn: async (...args) => {
      await pause(1000);
      return fetch(...args);
    },
  }),
  endpoints(builder) {
    return {
      fetchBrands: builder.query({
        providesTags: () => ["brands"],
        query: (pagination) => {
          return {
            url: pagination
              ? `brand?page=${pagination.page}&limit=${pagination.limit}`
              : "brand",
            method: "GET",
          };
        },
      }),
      postBrand: builder.mutation({
        invalidatesTags: () => ["brands"],
        query: (brand) => {
          return {
            url: "brand/",
            method: brand.id === 0 ? "POST" : "PUT",
            body: brand,
          };
        },
      }),
      deleteBrand: builder.mutation({
        invalidatesTags: () => ["brands"],
        query: (id) => {
          return {
            url: `brand?id=${id}`,
            method: "DELETE",
          };
        },
      }),
    };
  },
});

export const {
  useFetchBrandsQuery,
  useDeleteBrandMutation,
  usePostBrandMutation,
} = brandApi;

export { brandApi };
